module.exports = __webpack_public_path__ + "img/54-green.e2e9f406.svg";